/* eslint-disable react/react-in-jsx-scope */
import './style.css'

import exhibition from '../../img/news/photo_2025-03-20_13-55-58.jpg'

const News = () => {
  return (
    <div className="news center">
      <h1 className="news-title">
        Новости от <span className="yellow-span">FREE SUN FILM SCHOOL</span>
      </h1>

      <ul className="news-box">
        <li className="news-container">
          <img className="news-img" src={exhibition} />
          <p className="news-txt">
            Новая планета во Вселенной Киноиндустрии! Образовательная лицензия
            в&nbsp;2023. Киношкола&nbsp;сосредоточена на&nbsp;детальном изучении
            каждого предмета ,будь-то продюсирование, режиссура кино, сценарное
            и&nbsp;актерское мастерство. Лучшие студенты после окончания
            обучения гарантированно получают «Золотой Бонус» - стажировку
            на&nbsp;реальных проектах в&nbsp;Клубе Free Sun. В&nbsp;киношколе
            представлены базовые и&nbsp;авторские курсы.
          </p>
        </li>
      </ul>
    </div>
  )
}

export default News
